const
  NAME                = 'socialMore',
  VERSION             = '1.0.0',
  JQUERY_NO_CONFLICT  = $.fn[NAME],
  _window$            = $(window),
  INPUT_MEDIA_CLASS   = '.voc-input-media',
  AUTHOR_SOCIAL_CLASS = 'div.voc-author-social'
;

class SocialMore {
  constructor(element$) {
    this._element$ = element$;
    this._checkBoxSocialMore$ = element$.find(INPUT_MEDIA_CLASS);

    _window$.on('click', (e) => this.onClick(e));
  }

  onClick(e){
    // NOTE: Cerrar el panel de redes sociales adicionales si se hace click fuera de este.
    var target$ = $(e.target);

    if(!target$.parents(AUTHOR_SOCIAL_CLASS).length) {
      if (this._checkBoxSocialMore$.is(':checked')) {
        this._checkBoxSocialMore$.prop('checked', false);
      }
    }
  }

  static get VERSION() {
    return VERSION;
  }

  static _jQueryInterface(/*config*/) {
    return this.each(function() {
      new SocialMore($(this));
    });
  }
}

$.fn[NAME]             = SocialMore._jQueryInterface;
$.fn[NAME].Constructor = SocialMore;
$.fn[NAME].noConflict  = function noConflict() {
  $.fn[NAME] = JQUERY_NO_CONFLICT;
  return SocialMore._jQueryInterface;
};

export default SocialMore;



// WEBPACK FOOTER //
// ./src/plugins/social-more.js